import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import { dashboardservice } from "../../services/dashboard.service";
import { useTranslation } from "react-i18next";
import clearWebStorage from "../clearWebStorage";

const UserMenu = () => {
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  const [t] = useTranslation();
  const brandName = localStorage.getItem("brandName");
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const [initials, setInitials] = useState<string>("");

  const [userInfo, setUserInfo] = useState<any>({
    firstName: " ",
    gender: " ",
    lastName: " ",
    profileImgUrl: " ",
  });

  const uaePassLogout: any = process.env.REACT_APP_UAEPASS_LOGOUT;

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user") ?? "");
    setUserInfo(user);
    getInitials();
  }, []);

  const getInitials = () => {
    const fullName = userData.firstName + " " + userData.lastName;
    const names = fullName.split(" ");
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    setInitials(initials);
  };

  let logout = async (e: any) => {
    e.preventDefault();
    authCtx.toggleLoader(true);
    await dashboardservice.logout();
    authCtx.toggleLoader(false);
    authCtx.setMobile("", "");
    authCtx.removeUserInfo();
    authCtx.removeApiToken();

    if (localStorage.getItem("uaeUser") === "1") {
      localStorage.setItem("uaeUser", "0");
      window.location.replace(uaePassLogout);
    } else {
      history.push("/home/login");
    }
    clearWebStorage();
    if (brandName === "burjeel" && userData.facilityId === "BM10") {
      let theme: any = document.getElementById("theme");
      theme.href = "/css/theme-burjeel.css";
      document.title = "Burjeel | Patient Portal";
    }
  };

  return (
    <div className="dropdown caret-none caret-sm-inline-block d-inline-block ms-sm-3 ms-2 t-n10">
      <div
        className="dropdown-toggle d-block text-dark text-decoration-none fw-bold cursor-pointer"
        data-bs-toggle="dropdown"
      >
        <div className="img-36 d-inline-flex align-items-center justify-content-center text-primary rounded-circle light-bg me-sm-2">
          <span className="fs-18">{initials}</span>
        </div>
        <span className="d-none d-sm-inline-block">
          {" "}
          {t("Hi")} {userInfo.firstName}
        </span>
      </div>
      <ul className="dropdown-menu shadow-sm border-0 mt-2 fs-12">
        <li>
          <Link
            to="/auth/profile"
            className="dropdown-item d-flex align-items-center py-2"
          >
            <i className="material-icons-outlined me-2"> person_outline </i>
            {t("My Profile")}
          </Link>
        </li>
        <li>
          <Link
            to="/auth/needhelp"
            className="dropdown-item d-flex align-items-center py-2"
          >
            <i className="material-icons-outlined me-2"> support </i>
            {t("Need Help?")}
          </Link>
        </li>
        <li>
          <Link
            to="/auth/feedback"
            className="dropdown-item d-flex align-items-center py-2"
          >
            <i className="material-icons-outlined me-2"> rate_review </i>
            {t("Feedback & Complaint")}
          </Link>
        </li>
        <li>
          <Link
            to="/"
            onClick={logout}
            className="dropdown-item d-flex align-items-center py-2"
          >
            <i className="material-icons-outlined me-2"> power_settings_new </i>
            {t("Logout")}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default UserMenu;
